import {dd,store,app} from 'systems/imports'

class BaseApi{
    constructor() {}
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/api/BaseApi.js